module.exports = __webpack_public_path__ + "img/ic_job_alerts.1a54baea.svg";